import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { combineLatest } from 'rxjs';
import { PermissionConstants } from '../../../models/const.PermissionConstants';


@Injectable({
  providedIn: "root"
})
export class SecurityService implements Resolve<[models.UserDetails, string[]]> {
  constructor(private http: HttpClient) {
    this.userDetailsObservable = this.http.get<models.UserDetails>('api/Security/GetUserDetails')
      .toPromise().then((userDetails) => this.userDetails = userDetails)
      ;

    this.userPermissionsObservable = this.http.get<string[]>('api/Security/GetUserPermissions')
      .toPromise().then((userPermissions) => this.userPermissions = userPermissions)
      ;
  }

  public userDetails: models.UserDetails;
  public userDetailsObservable: Promise<models.UserDetails>;

  public userPermissions: string[];
  public userPermissionsObservable: Promise<string[]>;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return combineLatest(this.userDetailsObservable, this.userPermissionsObservable);
  }

  public userHasPermission(permission: string) {
    return this.userPermissions.findIndex((userPerm) => permission === userPerm) >= 0;
  }

  public canUserSaveData() {
    return this.userHasPermission(PermissionConstants.WorkflowEditPage.saveData);
  }

  public isUserPgpv() {
    return this.userDetails.informationGroups.findIndex((userPerm) => "PGPV" === userPerm) >= 0;
  }
  public isUserPgpt() {
    return this.userDetails.informationGroups.findIndex((userPerm) => "PGPT" === userPerm) >= 0;
  }

  public isUserServico(): boolean {
    return this.userDetails.informationGroups.findIndex((userPerm) => "PGPS" === userPerm) >= 0;
  }
}
